// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__1vXv5","wrapper":"Search_wrapper__mBjaf","iconWrapper":"Search_iconWrapper__ZSNbA"};